module.exports = __webpack_public_path__ + "static/media/icn_home.d5ff57ec.svg";